import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

function ResetearPassword() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmarPassword, setConfirmarPassword] = useState('');
    const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (password !== confirmarPassword) {
            setMensaje({ texto: '❌ Las contraseñas no coinciden.', tipo: 'error' });
            return;
        }
        
        setMensaje({ texto: 'Actualizando...', tipo: 'info' });

        try {
            // --- MODIFICADO ---
            const response = await fetch('/api/resetear-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message);
            }

            setMensaje({ texto: `✅ ${data.message}`, tipo: 'exito' });

            setPassword('');
            setConfirmarPassword('');

            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (error) {
            setMensaje({ texto: `❌ ${error.message}`, tipo: 'error' });
        }
    };

    const getAlertClass = () => {
        if (mensaje.tipo === 'exito') return 'alert-success';
        if (mensaje.tipo === 'error') return 'alert-danger';
        return 'alert-info';
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="card shadow p-4 text-center" style={{ width: '100%', maxWidth: '500px' }}>
                <h2>Restablecer Contraseña</h2>
                <p className="text-muted">Ingresa tu nueva contraseña.</p>
                <form onSubmit={handleSubmit} className="mt-3">
                    <div className="mb-3">
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Nueva contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Confirmar nueva contraseña"
                            value={confirmarPassword}
                            onChange={(e) => setConfirmarPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Guardar Contraseña</button>
                </form>
                {mensaje.texto && (
                    <div className={`alert ${getAlertClass()} mt-3`}>
                        {mensaje.texto}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ResetearPassword;